export default __webpack_public_path__ + "static/media/afropop.20bf3a30.jpg";